import * as React from "react";
import { createWorkersContextValue, WorkersContext } from "./context";

export const WorkersProvider = ({ children }: React.PropsWithChildren) => {
  const value = React.useMemo(() => createWorkersContextValue(), []);
  return (
    <WorkersContext.Provider value={value}>{children}</WorkersContext.Provider>
  );
};
